module.exports = __webpack_public_path__ + "static/mc-telefon-fe05171e37ac7db99af078e11fceb2e9.png";